
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { YearSetup } from "../../../components/Year";

export const TaxYearSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Year Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Years", navigateTo: "/years/list" },
      { text: "Create Year", navigateTo: "/years/setup" }
      ]}
      mainContents={<YearSetup testId="year-setup-page" />}
    />
  );
};
